import { APIClientListrequest, APIindustryClientListrequest } from '../assets/requests/request';

const buildClientList = ({ commit, getters }) => {
  const requestParams = {
    headers: { 'x-dashboard-token': getters['$_login/accessToken'] },
    auth: {
      username: getters['$_login/userName'],
      password: '',
    },
  };
  APIClientListrequest.get('', requestParams).then((response) => {
    commit('updateClientList', []);
    const allIndustriesObj = [
      {
        display_name: 'All Clients',
        username: 'all',
      },
    ];

    let rawResponse = response.data.clients;

    rawResponse = rawResponse.map((element) => ({
      display_name: element.display_name,
      username: element.username,
    }));

    const sortedResponse = rawResponse.sort(
      (a, b) => a.display_name.localeCompare(b.display_name),
    );

    const clientListArray = allIndustriesObj.concat(sortedResponse);

    commit('updateClientList', clientListArray);
    commit('updateBuildClientList', true);
  })
    .catch((error) => error);
};

const buildIndustryClientLists = ({ getters, rootState }) => {
  const allIndustriesObject = {
    clientList: [],
    sectorIndex: 0,
    industryName: 'All Industries',
    numberOfClients: 0,
  };

  rootState.clientByIndustryLists = [allIndustriesObject]; // eslint-disable-line

  const requestParams = {
    headers: { 'x-dashboard-token': getters['$_login/accessToken'] },
    auth: {
      username: getters['$_login/userName'],
      password: '',
    },
  };

  const industriesToGet = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20];

  for (let industryToGet = 0; industryToGet < industriesToGet.length; industryToGet += 1) {
    APIindustryClientListrequest.get(`/${industriesToGet[industryToGet]}`, requestParams).then((response) => {
      const clientListObject = {
        sectorIndex: industriesToGet[industryToGet],
        industryName: response.data.clientsFor,
        clientList: response.data.clients,
        numberOfClients: 0,
      };

      if (getters.clientOrRareMode === 'rare') {
        clientListObject.numberOfClients = response.data.clients.length;
        rootState.clientByIndustryLists.push(clientListObject);
        rootState.clientList.concat(response.data.clients);
        rootState.clientByIndustryLists.sort((a, b) => a.sectorIndex - b.sectorIndex);
      } else if (response.data.clients.length >= 5) {
        rootState.clientByIndustryLists.push(clientListObject);
        rootState.clientList.concat(response.data.clients);
        rootState.clientByIndustryLists.sort((a, b) => a.sectorIndex - b.sectorIndex);
      }
    }, (error) => {
      throw new Error(error.message);
    });
  }
};

export default {
  buildClientList,
  buildIndustryClientLists,
};
